// Tour target IDs for Operator Panel
export const OPERATOR_PANEL_TOUR_IDS = {
  MAIN_CONTAINER: 'operator-panel-main',
  HEADER: 'operator-panel-header',
  STATUS_AREA: 'operator-panel-status',
} as const;
